import { SafeJSON } from './../../shared/safe-json';

export class RelatedEvent {
    private json: any;

    constructor(json: any) {
        this.json = json;
    }

    getDate(): string {
        return SafeJSON.get('date', this.json);
    }

    getTime(): string {
        return SafeJSON.get('time', this.json);
    }

    getEventDesc(): string {
        return SafeJSON.get('eventDesc', this.json);
    }

    getTypeDesc(): string {
        return SafeJSON.get('typeDesc', this.json);
    }

    getEventOutcomeDesc(): string {
        return SafeJSON.get('eventOutcomeDesc', this.json);
    }

    getPresidingJudgeName(): string {
        return SafeJSON.get('presidingJudgeName', this.json);
    }

    getLocationId(): string {
        return SafeJSON.get('locationId', this.json);
    }

    // getCourtRoomCode(): string {
    //     return SafeJSON.get('courtRoomCode', this.json);
    // }

    // getCourtRoom(): string {
    //     return SafeJSON.get('courtRoomCode', this.json);
    // }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/related-event.ts